export default __webpack_public_path__ + "static/media/greenswapp_app.18a555dc.jpeg";